import { GetStaticProps } from "next";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTina } from "tinacms/dist/react";
import { TinaMarkdown } from "tinacms/dist/rich-text";

import { getWebsiteUrl } from "@/constants";
import BlogPageSeo from "@/shared/components/BlogPageSeo";
import Layout from "@/shared/components/layout";
import client from "tina/__generated__/databaseClient";

export default function NewContent(props: any) {
    const router = useRouter();
    const maindata = useTina({
        query: props.query,
        variables: props.variables,
        data: props.data,
    });
    const { page } = router.query;
    const content = maindata.data?.news?.content;
    const title = maindata.data?.news?.title;
    const heroImage = maindata.data?.news?.heroImage;
    const author = maindata.data?.news?.author;
    const filename = props?.data?.news?._sys?.filename;
    const publishDate = props?.data?.news?.date_published;
    const estimatedReadingTime = props?.data?.news?.estimatedReadingTime;
    const canonicalUrl = props?.data?.news?.canonicalUrl;
    const heroImageAltText = props?.data?.news?.heroImageAltText;
    const description = props?.data?.news?.description;
    const url = `${getWebsiteUrl()}/news/${filename}`;

    return (
        <Layout>
            <BlogPageSeo
                title={title}
                author={author}
                url={url}
                description={description}
                canonicalUrl={canonicalUrl}
                estimatedReadingTime={estimatedReadingTime}
                heroImageUrl={heroImage}
                publishDate={publishDate}
            />
            <div className="multipleLayoutWrap">
                <div className='singleLayout resourcePage'>
                    <div className="backLink">
                        <Link href={`/news${page ? `?page=${page}` : ""}`}>Back to news</Link>
                    </div>
                    {
                        title
                        && <h1 className="title">
                            {title}
                        </h1>
                    }
                    {
                        heroImage
                        && <Image
                            src={heroImage}
                            alt={heroImageAltText ? heroImageAltText : "News Image"}
                            className="heroImage"
                            loading="lazy"
                            width={600}
                            height={600}
                        />
                    }
                    <div className="markdown">
                        <TinaMarkdown content={content} />
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export const getStaticProps: GetStaticProps<any, { filename: string }> = async ({ params }) => {
    const tinaProps = await client.queries.news({
        relativePath: `${params?.filename}.md`,
    });
    const props = {
        ...tinaProps,
        enableVisualEditing: process.env.VERCEL_ENV === "preview",
    };
    return {
        props: JSON.parse(JSON.stringify(props)) as typeof props,
    };
};

export const getStaticPaths = async () => {
    const pagesListData = await client.queries.newsConnection();
    return {
        paths: pagesListData.data.newsConnection?.edges?.map((page) => ({
            params: { filename: page?.node?._sys.filename },
        })),
        fallback: false,
    };
};
